define('features/tools-page',[
  'jquery',
  'responsive',
  'bat',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add'
], function (
  $,
  responsive,
  bat,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var toolsPage = toolsPage || {
    init: function (el) {
      var self = this;
      var $scope = $(el);
      self.$scope = $scope;
      // Need to setTileLinks on each '.tools-cell'
      // in order to create a new context for each dataLayer within
      $('.tools-cell').each(function (idx, item) {
        self.setTileLinks(item);
      });

      self.analytics();
      self.addListeners();
    },

    positionCTA: function (item) {
      var cta = item.find('.tool-page-link');
      item.css('opacity', '1');
      cta.css({
        position: 'absolute',
        opacity: 1,
        bottom: '20px'
      });
    },

    setHeights: function () {
      var self = this;
      // BAT 2585: FIND TALLEST ITEM IN ROW, SET HEIGHTS ACCORDIN TO THAT:
      $('#components-tools').find('.tool-row').each(function (a, b) {
        var therow = $(b);
        var theCols = therow.find('.copy-tool-type');
        var rowH = 0;
        // FIND THE TALLEST COLUMN
        if (theCols.length > 3) { // WWW 'ADDITIONAL' HAS MORE THAN 3 ITEMS.
          var tempCount = 0;
          var fixrow = [];
          var total = 0;
          theCols.each(function (index, item) {
            fixrow.push(item);
            tempCount ++;
            total ++;
            var remainder = (theCols.length - total);
            if (tempCount === 3 || remainder === 0) {
              for (var i = 0; i < fixrow.length; i++) {
                var $col = $(fixrow[i]);
                if (rowH === 0 || $col.height() > rowH) {
                  rowH = $col.height();
                }
              }
              for (var i = 0; i < fixrow.length; i++) {
                var $col = $(fixrow[i]);
                $col.height(rowH);
                self.positionCTA($col);
              }
              rowH = 0;
              tempCount = 0;
              fixrow = [];
            }
          });
        } else {
          theCols.each(function (index, item) {
            var $item = $(item);
            // var $a = $item.find('a');
            // TODO: this apply_for_credit link may be outdated. It doesn't exist in preprod
            var isApplyForCredit = $item.attr('href').indexOf('apply_for_credit') !== -1;
            if (responsive() === 'sm' && isApplyForCredit) {
              // HIDE APPLY FOR CREDIT ON MOBILE'
              $item.addClass('hidden-sm');
            }
            if (rowH === 0 || $item.height() > rowH && !isApplyForCredit) {
              rowH = $item.height();
            }
          });

          // AND SET HEIGHT OF EACH COL TO BE THAT OF HIGHEST
          theCols.each(function (index, item) {
            var $itemToSet = $(item);
            $itemToSet.height(rowH);
            self.positionCTA($itemToSet);
          });
        }
      });
    },

    setTileLinks: function (parent) {
      var tiles = $(parent).find('.copy-tool-type');
      var content_section = $(parent).find('h2').text();
      // BAT-4395 add anayltics to tool divs
      tiles.each(function (index, item) {
        var $item = $(item);
        var $anchor = $item.find('a');
        var link_text = $(item).find('h3').text();
        var idx = index;
        $item.addClass('datalayer-link');
        $item.add($anchor).attr('data-layer', JSON.stringify({
          link_text: link_text,
          list_item_index: String(idx += 1),
          content_section: content_section
        }));

        /* $item.click(function () {
          var target = $anchor.prop('target') ? $anchor.prop('target') : '_self';
          window.open($anchor.attr('href'), target);
        }); */

        // BAT-3646 stop bubbling of link within parent div
        /* $anchor.click(function (e) {
          $item.trigger('click');
          e.preventDefault();
          e.stopImmediatePropagation();
        }); */
      });
    },

    analytics: function () {
      var $scope = this.$scope;

      anAddContext(
        $scope,
        blocks.sectionBlock('Shopping Tools')
      );
      anClicks($scope);
      anPageLoad($scope);
    },

    addListeners: function () {
      var self = this;
      $(window).resize(function () {
        self.setHeights();
      });

      $(function () {
        $(document).ready(function () {
          self.setHeights();
        });
        bat.util.loader.hideLoader();
      });
    }
  };
  return toolsPage;
});

